import React, { FC } from 'react'
import { Container } from '@cleartrip/ct-design-components'
import { HomeSearchContainer } from '@/components/oldComponents/Dropdown'

import styles from './index.module.scss'
import { queryFormat } from '@/components/oldComponents/Dropdown/HomeSearchContainer'

export interface HomeFormType {
    query: queryFormat
    setQuery: (newQuery: Partial<queryFormat>) => void
    setShowVisaBanner: (arg1: boolean) => void
    setShowBanner: (arg1: boolean) => void
    isExploreEnabled?: boolean
    offerConfigReady?: number | Record<string, never>
}

const HomeForm: FC<HomeFormType> = ({
    query,
    setQuery,
    setShowVisaBanner,
    setShowBanner,
    isExploreEnabled = false,
    offerConfigReady,
}) => {
    return (
        <Container className="p-10 pt-8 w-100p">
            <HomeSearchContainer
                query={query}
                setQuery={setQuery}
                setShowVisaBanner={setShowVisaBanner}
                setShowBanner={setShowBanner}
                isExploreEnabled={isExploreEnabled}
                offerConfigReady={offerConfigReady}
            />
        </Container>
    )
}

export default HomeForm
